import styled from 'styled-components';

import { layout, media } from '@prisjakt/ui-base';

import { speedToDurationMs, Speed } from '@prisjakt/ui';

const padding = layout.spacing.xSmall;
const contentWidth = layout.sidebarContentWidth.desktop;
const menuWidth = layout.sidebarMenuWidth.desktop;

const pageWithSidebarContent =
  layout.pageContent.maxWidth.value +
  layout.pageContent.gutter.value +
  (contentWidth.value + menuWidth.value) * 2;

type SidebarProps = {
  tab: 'none' | 'lists' | 'alerts' | 'filter';
};

export const Sidebar = styled.div<SidebarProps>`
  display: flex;
  flex-shrink: 0;
  width: ${props =>
    props.tab === 'none'
      ? menuWidth.rem
      : `calc(${contentWidth.rem} + ${menuWidth.rem})`};
  transition: width ${speedToDurationMs[Speed.Slow]}ms ease;
  grid-row: 1 / span 2;

  /* Reserve space between page content and sidebar menu to properly align page content */
  /* Debug or see how it works by setting a background color to this component */
  @media ${`(min-width: ${pageWithSidebarContent}px)`} {
    width: calc(${contentWidth.rem} + ${menuWidth.rem});
  }
  @media ${`(max-width: ${pageWithSidebarContent}px)`} {
    min-width: calc((100vw - ${layout.pageContent.maxWidth.rem}) / 2);
  }

  ${media.mediumDown`
    display: none;
  `};
`;

export const Sticky = styled.div`
  display: flex;
  position: fixed;
  height: calc(100vh - ${layout.headerHeight.desktop.rem});
  z-index: 11;
`;

export const SidebarMenu = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  width: ${menuWidth.rem};
  background-color: ${p => p.theme.colors.base100};
  padding: ${padding} 0;
  z-index: 99;
`;

export const SidebarContent = styled.div.attrs({ role: 'dialog' })`
  position: relative;
  flex-shrink: 0;
  width: ${contentWidth.rem};
  border-right: 1px solid ${p => p.theme.lines.primary};
  overflow: auto;
  overscroll-behavior: contain;
  background: ${p => p.theme.bg.primary};
  z-index: 10;
  flex-direction: column;
`;

export const SidebarFilter = styled.div`
  height: 100%;
`;
